<template>
  <div class="content-tab">
    <div
      v-for="item in tabs"
      @click="handleClick(item.value)"
      :key="item.value"
      :class="['tab', value === item.value ? 'active' : 'inactive']"
      :style="
        theme && value === item.value
          ? {
              color: theme.activeTextColor
            }
          : {}
      "
    >
      {{ item.label }}
      <i
        :style="
          theme
            ? {
                backgroundColor: theme.activeTextColor
              }
            : {}
        "
      ></i>
    </div>
  </div>
</template>
<script>
export default {
  name: "ContentTab",
  data() {
    return {
      value: 1,
      tabs: [
        { label: "最新发帖", value: 1 },
        { label: "最新回复", value: 2 },
        { label: "热门文章", value: 3 }
      ]
    };
  },
  methods: {
    handleClick(data) {
      if (data !== this.value) {
        this.value = data;
        this.$emit("change", this.value);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.content-tab {
  width: fit-content;
  display: flex;
  gap: 33px;
  .tab {
    position: relative;
    user-select: none;
    cursor: pointer;
    line-height: 62px;
    font-size: 20px;
    i {
      position: absolute;
      bottom: 0;
      height: 2px;
      width: 40px;
      left: 50%;
      transform: translateX(-50%);
      background-color: var(--zs-qz-tabs-text-active-color);
      opacity: 0;
    }
    &.inactive {
      color: var(--zs-qz-tabs-text-color);
    }
    &.active {
      color: var(--zs-qz-tabs-text-active-color);
      i {
        opacity: 1;
      }
    }
  }
}
</style>
